import './style.scss';
import {categorizationNumber} from "../../../lib/utils/helpers/categorizationNumber";
import {normalizeCurrency} from "../../../lib/utils/helpers";
import {useEffect, useState} from "react";
import {usePublicEndpoints} from "../../../lib/api/usePublicEndpoints";
import {t} from "i18next";
import ElementWithAccessInCountries from "../../../lib/utils/hocs/ElementWithAccessInCountries";
import Spinner from "../Spinner";
import {useInfiniteScroll} from "../../../lib/utils/hooks/useInfiniteScroll";
import {useGroupByYear} from "../../../lib/utils/hooks/useGroupByYear";
import SubscriptionHistoryList from "./SubscriptionHistoryList";

const calcInitialLimit = () => {
    const availableHeight = window.innerHeight - 180;
    return Math.floor(availableHeight / 66);
}

const SubscriptionDetails = ({subscriptionData}) => {
    const {
        deposit_sum,
        subscription_price_currency,
        keel_all_luch_group_discount_size,
        luch_individual_discount_size,
        race_discount_size,
        cup_discount_size,
        id: clientId,
    } = subscriptionData;

    const { getCurrencies, getSubscriptionHistory } = usePublicEndpoints();
    const [currencies, setCurrencies] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const currency = normalizeCurrency(subscription_price_currency, currencies) || '';

    const {groupedData: groupedSubscriptions, hasData: isGroupedSubscriptions} = useGroupByYear(subscriptions);

    const getSubscriptionDetails = async (limit) => {
        if (isLoading) return;
        setIsLoading(true);
        const res = await getSubscriptionHistory({
            _limit: limit || 10,
            _start: page * (limit || 10)
        });
        const newSubscriptions = res?.data || [];

        setSubscriptions(prev => [...prev, ...newSubscriptions]);
        setPage(prev => prev + 1);

        if (newSubscriptions.length < (limit || 10)) {
            setHasMore(false);
        }

        setIsLoading(false);
    }

    useEffect(() => {
        if(clientId) getSubscriptionDetails(calcInitialLimit())
    }, [clientId]);

    const sentinelRef = useInfiniteScroll(
        () => {
            if (!isLoading && hasMore) {
                getSubscriptionDetails(10);
            }
        },
        [hasMore, isLoading]
    );


    useEffect(() => {
        getCurrencies()
            .then(res => setCurrencies(res))
    }, []);

    return (
        <div className='subscription-details'>
            <div className="subscription-balance">
                <div className="input-label">{t('subscriptions.subscriptionRemainder')}</div>
                <div class="subscription-balance__amount">
                    {categorizationNumber(deposit_sum)}&nbsp;{currency}
                </div>
            </div>
            <div className="subscription-discounts">
                <div className="input-label">{t('discounts.discountSubscriptions')}</div>
                <div class="subscription-discounts__wrap">
                    <div className="subscription-discounts__item">
                        <div className="subscription-discounts__amount">{keel_all_luch_group_discount_size}%</div>
                        <div className="subscription-discounts__label">{t('discounts.discountOnYachtLuch')}</div>
                    </div>
                    <div className="subscription-discounts__item">
                        <div className="subscription-discounts__amount">{luch_individual_discount_size}%</div>
                        <div className="subscription-discounts__label">{t('discounts.discountOnGroupYachtLuch')}</div>
                    </div>
                    <ElementWithAccessInCountries hideInCountries={['EN']}>
                        <div className="subscription-discounts__item">
                            <div className="subscription-discounts__amount">{race_discount_size}%</div>
                            <div className="subscription-discounts__label">{t('discounts.discountOnRace')}</div>
                        </div>
                    </ElementWithAccessInCountries>
                    <div className="subscription-discounts__item">
                        <div className="subscription-discounts__amount">{luch_individual_discount_size}%</div>
                        <div className="subscription-discounts__label">{t('discounts.discountOnIndividualLuch')}</div>
                    </div>
                    <div className="subscription-discounts__item">
                        <div className="subscription-discounts__amount">{cup_discount_size}%</div>
                        <div className="subscription-discounts__label">{t('discounts.discountOnCup')}</div>
                    </div>
                </div>
            </div>
            <div class="divider no-margin mt-5 mb-5"></div>
            <div class="history-block">
                <div class="history-block__title">История</div>
                {isGroupedSubscriptions && (
                    <SubscriptionHistoryList groupedSubscriptions={groupedSubscriptions} />
                )}
                {isLoading && (
                    <Spinner/>
                )}
                <div ref={sentinelRef}></div>
            </div>
        </div>
    )
}

export default SubscriptionDetails